import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveDigitalPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export const waterTemperatureGlobalCodes = new Map<string, string>();
export const waterTemperatureHelperCode = `float _sbeGetWaterTemperature(DallasTemperature& sensors) {\n  sensors.requestTemperatures();\n  return sensors.getTempCByIndex(0);\n}\n`;

let _used = false;

export function waterTemperatureUsed(): boolean {
    return _used;
}

export function resetWaterTemperature(): void {
    _used = false;
    waterTemperatureGlobalCodes.clear();
}

export function register(gen: any): void {
    gen.forBlock['water_temperature'] = function (block: Blockly.Block): [string, number] {
        const pin = resolveDigitalPin(block);
        const varName = `_waterTempSensors_${pin}`;
        const wireVarName = `_waterTempWire_${pin}`;

        waterTemperatureGlobalCodes.set(
            pin,
            `OneWire ${wireVarName}(${pin});\nDallasTemperature ${varName}(&${wireVarName});\n`,
        );
        registerSetupCode(pin, `  ${varName}.begin();\n  ${varName}.setResolution(SENSOR_BIT);\n`);

        _used = true;
        return expr(`_sbeGetWaterTemperature(${varName})`);
    };
}
